import * as React from "react"
const SvgArrowLeft = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7.821 13.292H19a.97.97 0 0 0 .712-.287.97.97 0 0 0 .288-.713.97.97 0 0 0-.288-.712.97.97 0 0 0-.712-.288H7.82l4.902-4.899q.3-.3.287-.7a1 1 0 0 0-.312-.7 1.06 1.06 0 0 0-.7-.287.92.92 0 0 0-.7.288l-6.603 6.598q-.15.15-.213.325a1.1 1.1 0 0 0-.062.375q0 .2.062.375a.9.9 0 0 0 .213.325l6.602 6.599a.93.93 0 0 0 .688.275q.413 0 .713-.275.3-.3.3-.713 0-.412-.3-.712z" />
  </svg>
)
export default SvgArrowLeft
